import { createFileRoute } from '@tanstack/react-router';
import { RegisterFlow } from '../../features/auth/register-flow';

export const Route = createFileRoute('/_public/register')({
  component: RegisterFlow,
});
